import React from 'react';
import IconButton from '@mui/material/IconButton';

import ThinkingBubbleIcon from '../assets/thinking-bubble-icon.svg';

interface ThinkingBubbleToggleButtonProps {
    onClick: (e: React.MouseEvent) => void;
}

const ThinkingBubbleToggleButton: React.FC<ThinkingBubbleToggleButtonProps> = ({ onClick }) => (
    <IconButton size="small" onClick={onClick} sx={{ ml: 1 }}>
        <img src={ThinkingBubbleIcon} alt="Thinking Bubble" style={{ width: 20, height: 20 }} />
    </IconButton>
);

export default ThinkingBubbleToggleButton;
